/// <amd-module name="TFS/Admin/Common/Controls/DeleteProjectDialog/DeleteProjectDialog" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { IVssPageContext } from "VSS/Platform/Context";
import { VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { Link } from "VSSUI/Link";
import { TextField } from "VSSUI/TextField";
import { KeyCode } from "VSSUI/Util";

import * as AdminResources from "TFS/Admin/Common/Controls/Resources";
import { IDeleteProjectDialogProps } from "TFS/Admin/Common/Controls/DeleteProjectDialog/DeleteProjectDialog.Props";

interface IDeleteProjectDialogState {
    isMatch: boolean;
    hasClicked: boolean;
}

export class DeleteProjectDialog extends React.Component<IDeleteProjectDialogProps, IDeleteProjectDialogState> {
    private projectName = new ObservableValue<string>("");

    constructor(props: IDeleteProjectDialogProps) {
        super(props);
        this.state = {
            isMatch: false,
            hasClicked: false
        };
    }

    public render(): JSX.Element {
        return (
            <Dialog
                calloutClassName="delete-project-dialog"
                titleProps={{ text: AdminResources.DeleteProjectDialogTitle }}
                onDismiss={() => this.props.onCancel()}
                footerButtonProps={[
                    { text: AdminResources.Cancel, onClick: this.props.onCancel },
                    {
                        className: "delete-project-button",
                        danger: true,
                        disabled: !this.state.isMatch,
                        onClick: this.props.onDeleteProject,
                        text: AdminResources.DeleteButton
                    }
                ]}
            >
                <div className="delete-project-dialog-content">
                    <div className="delete-project-first-paragraph">
                        <FormatComponent format={AdminResources.DeleteProjectFirstParagraph}>
                            <span className="delete-project-name fontWeightSemiBold">{this.props.projectName}</span>
                        </FormatComponent>
                    </div>
                    <div className="delete-project-second-paragraph">
                        {AdminResources.DeleteProjectSecondParagraph}
                        <Link
                            className="learn-more-link"
                            href={AdminResources.DeleteProjectLearnMoreLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={AdminResources.DeleteProjectLearnMoreAriaLabel}
                        >
                            {AdminResources.DeleteProjectLearnMoreAriaLabel}
                        </Link>
                    </div>
                    <div className="delete-project-action-paragraph">
                        <FormatComponent format={AdminResources.DeleteProjectConfirmationText}>
                            <span className="delete-project-name fontWeightSemiBold">{this.props.projectName}</span>
                        </FormatComponent>
                    </div>
                </div>
                <TextField
                    className="delete-button-text-field"
                    onKeyDown={this._onKeyPress}
                    placeholder={AdminResources.DeleteProjectPlaceholderText}
                    onChange={this._onNameChanged}
                    value={this.projectName}
                    ariaLabel={AdminResources.DeleteProjectPlaceholderText}
                />
            </Dialog>
        );
    }

    private _onNameChanged = (event: any, value: string) => {
        this.projectName.value = value;
        this._validateProjectName(value);
    };

    // event.keycode returns zero so using which instead
    private _onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === KeyCode.enter && this.state.isMatch) {
            this.props.onDeleteProject();
        }
    };

    private _validateProjectName = (name: string): void => {
        if (localeIgnoreCaseComparer(name, this.props.projectName) === 0) {
            this.setState({ isMatch: true });
        } else {
            this.setState({ isMatch: false });
        }
        return undefined;
    };
}

VssComponent.register("ms.vss-admin-web.delete-project-dialog", DeleteProjectDialog);
